import request from "@/util/request";

// 头部nav
export function getDpPagePanel(data, series) {
  return request({
    url: "/api/dp/visual/getDpDataItemByCode",
    method: "get",
    params: {
      pagePanelCode: data,
      series: series || ""
    }
  });
}

// 检疫开证点标注
export function findPigTzNum() {
  return request({
    url: "/api/restful/findPigTzNum",
    method: "get"
  });
}

// 生猪屠宰开证
export function findPigTzTjArea(type) {
  return request({
    url: "/api/restful/findPigTzTjArea",
    method: "get",
    params: {
      type
    }
  });
}

// 一村一品 / 菜篮子基地 / 龙头企业 / 合作社
export function getScreenV2ByIndexIdGetLayer(indexId) {
  return request({
    url: "/api/restful/getScreenV2ByIndexIdGetLayer",
    method: "get",
    params: {
      indexId
    }
  });
}

// 家庭农场 / 农资经营企业 / 生产基地 | 3, 5, 6
export function findOrgCompanyNumByType(type) {
  return request({
    url: "/api/restful/findOrgCompanyNumByType",
    method: "get",
    params: {
      type
    }
  });
}

// 总览-农业产值变化趋势
export function trendsInAgriculturalOutputValue() {
  return request({
    url: "/api/restful/cyzl/trendsInAgriculturalOutputValue",
    method: "get"
  });
}

// 畜牧业-动物检疫开证量
export function findPigTzAreaQsByType(data) {
  return request({
    url: "/api/restful/findPigTzAreaQsByType",
    method: "get",
    params: data
  });
}

// 根据code获取大屏数据
export function getDpDataItemByCode(data) {
  return request({
    url: "/api/dp/visual/getDpDataItemByCode",
    method: "get",
    params: data
  });
}

// 农作物生产情况
export function findQueryList(data) {
  return request({
    url: "/api/dp/visual/queryList",
    method: "get",
    params: data
  });
}
